import { API_URL } from '../api';
import { chatMediaUrl, attachmentFromMessage } from './chatMediaUrl';
import { getAuthToken } from '../auth';
export { chatMediaUrl } from './chatMediaUrl';

const pending = new Map();
export async function freshChatAttachment(attachment, chatId, messageId) {
  if (!chatId || !messageId || !attachment?.id) {
    const url = chatMediaUrl(attachment?.url, API_URL);
    if (!url) throw new Error('Для файла не найдена ссылка');
    return { ...attachment, url };
  }
  const auth = getAuthToken() ? `Bearer ${getAuthToken()}` : '';
  if (!auth) throw new Error('Войдите в кабинет повторно');
  const key = `${auth}:${chatId}:${messageId}`;
  if (!pending.has(key)) {
    const route = `/chat/${encodeURIComponent(chatId)}/messages/?message_id=${encodeURIComponent(messageId)}&mark_read=0`;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    const request = fetch(new URL(route, API_URL).href, {
      headers: { Authorization: auth }, credentials: 'omit', redirect: 'error',
      referrerPolicy: 'no-referrer', signal: controller.signal,
    }).then(async response => {
      if (!response.ok) throw new Error(response.status === 401 ? 'Войдите в кабинет повторно'
        : response.status === 403 ? 'Нет доступа к материалам этого чата' : 'Не удалось обновить ссылку на файл');
      return response.json();
    }).catch(error => {
      if (error.name === 'AbortError' || error instanceof TypeError) throw new Error('Нет ответа от сервера. Проверьте соединение и повторите.');
      throw error;
    }).finally(() => { clearTimeout(timeout); pending.delete(key); });
    pending.set(key, request);
  }
  const fresh = attachmentFromMessage(await pending.get(key), messageId, attachment.id);
  const url = chatMediaUrl(fresh.url, API_URL);
  if (!url) throw new Error('Недопустимая ссылка на файл');
  return { ...fresh, url };
}

// Open the tab on the original tap to avoid iOS blocking it after the request.
export async function openChatAttachment(attachment, chatId, messageId) {
  const tab = window.open('about:blank', '_blank');
  if (!tab) throw new Error('Разрешите открытие новой вкладки для скачивания');
  tab.opener = null;
  try {
    const fresh = await freshChatAttachment(attachment, chatId, messageId);
    tab.location.replace(fresh.url);
  } catch (error) { tab.close(); throw error; }
}
